/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Duplicate_NoteInputs */

const cs_pm_duplicate_note = /** @type {(inputs: Pm_Duplicate_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dva nebo více inzerátů ukazují na stejnou nemovitost (např. duplicitní inzerát na portálu). Vyberte, který inzerát k ní patří; ostatní přeskočte.`)
};

const en_pm_duplicate_note = /** @type {(inputs: Pm_Duplicate_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or more listings point to the same property (e.g. a duplicate listing on the portal). Pick the one that belongs to it and skip the others.`)
};

/**
* | output |
* | --- |
* | "Two or more listings point to the same property (e.g. a duplicate listing on the portal). Pick the one that belongs to it and skip the others." |
*
* @param {Pm_Duplicate_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_duplicate_note = /** @type {((inputs?: Pm_Duplicate_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Duplicate_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_duplicate_note(inputs)
	return cs_pm_duplicate_note(inputs)
});